import styles from './SloganSection.module.css';

function SloganSection() {
  return (
    <section className={styles.container}>
      <p className={styles.slogan}>
        혼자서 해결하기 힘든 일상의 순간<br />
        <span className={styles.highlight}>시니어헬퍼</span>가 해결해 드립니다.
      </p>
    </section>
  );
}

export default SloganSection;
